import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-collage-record",
  "use": "icon-sms-collage-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-sms-collage-record\"><path d=\"M794.4 854H229.6c-15.8 0-31.2-6.6-42.1-18-10.9-11.5-16.7-27.1-15.9-42.9l28-567.8c1.5-31 27-55.2 58-55.2h508.7c31 0 56.5 24.3 58 55.2l28 567.8c0.8 15.8-5 31.4-15.9 42.9-10.8 11.4-26.2 18-42 18zM257.7 225.9c-1.1 0-2.1 0.9-2.1 2.1l-28 567.8c0 0.2-0.1 0.9 0.6 1.6 0.6 0.7 1.3 0.7 1.6 0.7h564.8c0.2 0 0.9 0 1.6-0.7 0.6-0.7 0.6-1.4 0.6-1.6L768.5 228c-0.1-1.2-1-2.1-2.1-2.1H257.7z\" fill=\"#ffffff\" p-id=\"3451\" /><path d=\"M669.7 467.3c-22.7 0-41.7-15.9-46.5-37.1-30.9 26.9-70 41.8-111.2 41.8-41 0-80.4-14.9-111.2-41.8-4.9 21.2-23.8 37-46.5 37-26.4 0-47.8-21.4-47.8-47.8s21.4-47.8 47.8-47.8 47.8 21.4 47.8 47.8c0 2-0.3 3.8-0.6 5.7l7.1-7.9C437 442.9 473.7 457 512 457c39.7 0 77.4-15 106.2-42.4l3.8 4c0.5-26 21.6-46.9 47.7-46.9 26.4 0 47.8 21.4 47.8 47.8 0.1 26.4-21.4 47.8-47.8 47.8z\" fill=\"#ffffff\" opacity=\".5\" p-id=\"3452\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-collage-record.svg
// module id = QsNw
// module chunks = 32